/* DO NOT MODIFY. This is an autogenerated file. */
/* eslint-disable */
import * as React from "react"
import type { SVGProps } from "react"

export const SvgArrowUpRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || "100%"}
    height={props.height || "100%"}
    fill="none"
    viewBox="0 0 24 24"
    data-name="SvgArrowUpRight"
    {...props}
  >
    {props.children}
    <path stroke="#000" strokeLinecap="round" strokeLinejoin="round" d="M7 17 17 7m0 0H7m10 0v10" />
  </svg>
)
